import { useEffect } from "react";
import { useState } from "react";
import "./PostageLogistics.css";
import ContactForm from "../../components/ContactUs/ContactUs";
import PostageImg from "../../assets/images/postage.png";
import {
  Package,
  Truck,
  Clock,
  Shield,
  Globe,
  Eye,
  MapPin,
  CheckCircle,
  Building2,
  Zap,
} from "lucide-react";

const PostageLogistics = () => {
  // Inline scroll to top functionality
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [showContact, setShowContact] = useState(false);

  const benefits = [
    {
      icon: Zap,
      title: "Speed",
      description:
        "Same day delivery in urgent cases, within 24 hours in Tirana and 48 hours in districts.",
    },
    {
      icon: Shield,
      title: "Safety",
      description:
        "Secure handling and transportation of all postal deliveries with complete protection.",
    },
    {
      icon: Globe,
      title: "Global Coverage",
      description:
        "100% coverage of Albanian territory with comprehensive logistics network.",
    },
    {
      icon: MapPin,
      title: "Tracking",
      description:
        "Real-time tracking and monitoring of all shipments throughout the delivery process.",
    },
    {
      icon: Eye,
      title: "Transparency",
      description:
        "Complete visibility into delivery status and transparent communication throughout.",
    },
  ];

  const services = [
    {
      icon: Package,
      title: "Custom Clearance Support",
      description:
        "Wide range of custom support for standard and non-routine clearance processes.",
    },
    {
      icon: Truck,
      title: "Bulk Cargo Transportation",
      description:
        "Freight transport by vans or trucks throughout Albania with loading/unloading services.",
    },
    {
      icon: Clock,
      title: "Express Pickup Service",
      description:
        "Pick-up of postal deliveries within 1 hour of customer request from sending addresses.",
    },
  ];

  const additionalFeatures = [
    "Pick-up from banking, state and private institutions",
    "Same day delivery for urgent cases",
    "24-hour delivery in Tirana for normal cases",
    "48-hour delivery in districts",
    "100% Albanian territory coverage",
    "Loading and unloading services included",
    "Smooth and efficient clearance processes",
    "Professional handling of all shipment types",
  ];

  return (
    <div className="postage-logistics-main-container">
      {/* Hero Section */}
      <section className="postage-logistics-hero-wrapper">
        <div className="postage-logistics-content-width">
          <div className="postage-logistics-hero-layout">
            <div className="postage-logistics-hero-content">
              <div className="postage-logistics-tagline">
                <span className="postage-logistics-tagline-text">
                  Reliable postal delivery
                </span>
                <span className="postage-logistics-tagline-highlight">
                  across Albania.
                </span>
              </div>
            </div>
            <div className="postage-logistics-hero-main">
              <div className="postage-logistics-hero-icon">
                <Package className="postage-logistics-hero-package-icon" />
                {/* <div className="postage-logistics-icon-grid">
                  <div className="postage-logistics-grid-line"></div>
                  <div className="postage-logistics-grid-line"></div>
                  <div className="postage-logistics-grid-line"></div>
                  <div className="postage-logistics-grid-line"></div>
                </div> */}
              </div>
              <div className="postage-logistics-hero-text">
                <h1 className="postage-logistics-hero-title">
                  POSTAGE LOGISTICS
                </h1>
                <p className="postage-logistics-hero-description">
                  Postage system pick-up of postal deliveries from the sending
                  addresses of various banking, state and other private
                  institutions, within 1 hour of the request of the sending
                  customer. We offer the same day delivery in urgent cases,
                  within 24 hours in Tirana in normal cases and 48 hours in the
                  districts, with 100% coverage of the Albanian territory.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Postage System Section */}
      <section className="postage-logistics-system-section">
        <div className="postage-logistics-content-width">
          <div className="postage-logistics-system-content">
            <h2 className="postage-logistics-system-title">Postage System</h2>
            <div className="postage-logistics-system-description">
              <p>
                Helps you with the bulk cargo transportation service. These
                include freight transport by vans or trucks throughout Albania,
                with 100% territory coverage. Attached to this transport is the
                loading and unloading service, at the request of the customer.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="postage-logistics-services-section">
        <div className="postage-logistics-content-width">
          <div className="postage-logistics-center-align">
            <h2 className="postage-logistics-services-title">Services</h2>
            <p className="postage-logistics-services-description">
              We offer a wide range of custom support for standard clearance
              processes as well as non-routine clearance processes. By ensuring
              that clearance is a smooth and efficient process, we ensure that
              your shipment arrives as soon as possible.
            </p>
          </div>

          <div className="postage-logistics-services-grid">
            {services.map((service, index) => {
              const Icon = service.icon;
              return (
                <div key={index} className="postage-logistics-service-card">
                  <div className="postage-logistics-service-card-header">
                    <div className="postage-logistics-service-card-icon">
                      <Icon className="postage-logistics-medium-icon" />
                    </div>
                    <h3 className="postage-logistics-service-card-title">
                      {service.title}
                    </h3>
                  </div>
                  <div className="postage-logistics-service-card-body">
                    <p className="postage-logistics-service-card-description">
                      {service.description}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Logistics Image Section */}
      <section className="postage-logistics-image-section">
        <div className="postage-logistics-content-width">
          <div className="postage-logistics-center-align">
            <h2 className="postage-logistics-image-heading">
              Comprehensive Postage & Logistics Solutions
            </h2>
            <p className="postage-logistics-image-description">
              Experience efficient postal delivery and logistics management with
              complete Albanian territory coverage.
            </p>
            <div className="postage-logistics-image-container">
              {/* IMAGE PLACEHOLDER - Replace with your actual postage logistics image */}
              <img
                src={PostageImg}
                alt="Postage logistics operations showing delivery trucks, sorting facilities, and package tracking systems across Albania"
                className="postage-logistics-showcase-image"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="postage-logistics-benefits-section">
        <div className="postage-logistics-content-width">
          <div className="postage-logistics-center-align">
            <h2 className="postage-logistics-benefits-title">Benefits</h2>
            <p className="postage-logistics-benefits-description">
              Transform your postal and logistics operations with comprehensive
              benefits and proven delivery results.
            </p>
          </div>

          <div className="postage-logistics-benefits-grid">
            {benefits.map((benefit, index) => {
              const Icon = benefit.icon;
              return (
                <div key={index} className="postage-logistics-benefit-card">
                  <div className="postage-logistics-benefit-card-header">
                    <div className="postage-logistics-benefit-card-icon">
                      <Icon className="postage-logistics-medium-icon" />
                    </div>
                    <h3 className="postage-logistics-benefit-card-title">
                      {benefit.title}
                    </h3>
                  </div>
                  <div className="postage-logistics-benefit-card-body">
                    <p className="postage-logistics-benefit-card-description">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Additional Features Section */}
      <section className="postage-logistics-features-section">
        <div className="postage-logistics-content-width">
          <div className="postage-logistics-center-align">
            <h2 className="postage-logistics-features-title">
              Key Features & Capabilities
            </h2>
            <p className="postage-logistics-features-description">
              Comprehensive postal logistics capabilities designed to enhance
              delivery efficiency and customer satisfaction.
            </p>
          </div>

          <div className="postage-logistics-features-grid">
            {additionalFeatures.map((feature, index) => (
              <div key={index} className="postage-logistics-feature-item">
                <CheckCircle className="postage-logistics-feature-check-icon" />
                <span className="postage-logistics-feature-text">
                  {feature}
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Coverage Section */}
      <section className="postage-logistics-coverage-section">
        <div className="postage-logistics-content-width">
          <div className="postage-logistics-coverage-content">
            <h2 className="postage-logistics-coverage-title">
              Complete Albanian Territory Coverage
            </h2>
            <p className="postage-logistics-coverage-description">
              Our extensive logistics network ensures reliable postal delivery
              services across all regions of Albania. From urban centers to
              remote districts, we provide consistent, professional service with
              guaranteed delivery timeframes and complete tracking capabilities.
            </p>
            <div className="postage-logistics-coverage-highlights">
              <div className="postage-logistics-coverage-highlight">
                <Clock className="postage-logistics-coverage-icon" />
                <span>1-Hour Pickup Response</span>
              </div>
              <div className="postage-logistics-coverage-highlight">
                <Truck className="postage-logistics-coverage-icon" />
                <span>Professional Fleet</span>
              </div>
              <div className="postage-logistics-coverage-highlight">
                <MapPin className="postage-logistics-coverage-icon" />
                <span>100% Territory Coverage</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="postage-logistics-cta-section">
        <div className="postage-logistics-content-width postage-logistics-center-align">
          <h2 className="postage-logistics-cta-title">
            Ready to Optimize Your Postal Logistics?
          </h2>
          <p className="postage-logistics-cta-description">
            Get started with our comprehensive postage logistics solutions and
            experience reliable delivery services across Albania with complete
            territory coverage.
          </p>
          <div className="postage-logistics-cta-buttons">
            <button
              className="postage-logistics-primary-button"
              onClick={() => setShowContact(true)}
            >
              <Package className="postage-logistics-small-icon" />
              Get Logistics Solutions
            </button>
          </div>
        </div>
      </section>

      {/* Contact Form Modal */}
      {showContact && (
        <div className="modal-overlay" onClick={() => setShowContact(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button
              className="modal-close"
              onClick={() => setShowContact(false)}
            >
              ✕
            </button>
            <ContactForm />
          </div>
        </div>
      )}
    </div>
  );
};

export default PostageLogistics;
